import React, { useCallback, useEffect, useState } from 'react'

import { useResizeObserver } from '@wojtekmaj/react-hooks'
import { pdfjs, Document, Page } from 'react-pdf'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import 'react-pdf/dist/esm/Page/TextLayer.css'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'
pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker

import { CButton, CModal, CModalBody, CModalHeader, CSpinner } from '@coreui/react-pro'
import { getTenderChapterPdf } from 'src/services/requests/tenders/tenders'
import { Spinner } from 'src/components/spinner/Spinner'
import CIcon from '@coreui/icons-react'
import { cilArrowCircleLeft, cilArrowCircleRight } from '@coreui/icons'

const resizeObserverOptions = {}

const maxWidth = 1000

const PDFView = ({ t, data, pdfModalVisible, setPdfModalVisible }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [pdfFile, setPdfFile] = useState()
  const [numPages, setNumPages] = useState()
  const [pageNumber, setPageNumber] = useState()
  const [containerRef, setContainerRef] = useState(null)
  const [containerWidth, setContainerWidth] = useState()

  const fetchTenderChapterPdf = (id) => {
    getTenderChapterPdf(id).then((result) => {
      setPdfFile(result.data)
    })
  }

  useEffect(() => {
    setNumPages(data?.endsOnPage)
    setPageNumber(data?.startsOnPage)
    fetchTenderChapterPdf(data?.id)
  }, [pdfModalVisible])

  const onResize = useCallback((entries) => {
    const [entry] = entries

    if (entry) {
      setContainerWidth(entry.contentRect.width)
    }
  }, [])

  useResizeObserver(containerRef, resizeObserverOptions, onResize)

  const onDocumentLoadProgress = () => {
    return <CSpinner color='primary' variant='grow' />
  }

  const onDocumentLoadSuccess = (pageCount) => {
    setNumPages(pageCount)
    setPageNumber(pageNumber)
  }

  const changePage = (offset) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset)
  }

  const previousPage = () => {
    changePage(-1)
  }

  const nextPage = () => {
    changePage(1)
  }

  return (
    <CModal
      size='xl'
      alignment='top'
      visible={pdfModalVisible}
      onClose={() => setPdfModalVisible(false)}
      aria-labelledby='PdfModal'
      className='pdfModal'
    >
      <CModalHeader className='pb-0' onClose={() => setPdfModalVisible(false)}></CModalHeader>
      <CModalBody>
        <div className='pdf-container'>
          <Spinner pageLoading={isLoading}>
            <div className='pdf-document-wrapper' ref={setContainerRef}>
              <div className='d-flex justify-content-center align-items-center'>
                <CButton
                  size='lg'
                  color='primary'
                  className='me-4 d-flex align-items-center'
                  disabled={pageNumber <= 1}
                  onClick={previousPage}
                >
                  <CIcon icon={cilArrowCircleLeft} size='xl' />
                </CButton>
                <Document
                  file={pdfFile}
                  loading={onDocumentLoadProgress}
                  onLoadSuccess={(pdf) => onDocumentLoadSuccess(pdf.numPages)}
                  noData={t('NoPDFSpecified')}
                >
                  <Page
                    pageNumber={pageNumber}
                    width={containerWidth ? Math.min(containerWidth, maxWidth) : maxWidth}
                  />
                </Document>
                <CButton
                  size='lg'
                  color='primary'
                  className='ms-4 d-flex align-items-center'
                  disabled={pageNumber >= numPages}
                  onClick={nextPage}
                >
                  <CIcon icon={cilArrowCircleRight} size='xl' />
                </CButton>
              </div>
              <div className='mt-3'>
                <p className='text-center text-white'>
                  {t('Page')} {pageNumber || (numPages ? 1 : '--')} {t('of')} {numPages || '--'}
                </p>
              </div>
            </div>
          </Spinner>
        </div>
      </CModalBody>
    </CModal>
  )
}
export default PDFView
